<script>
    import router from "page";
    import { onMount } from "svelte";

    import Modal from "../components/Modal.svelte";
    import DeleteModal from "../components/DeleteModal.svelte";

    import { TabulatorFull as Tabulator } from "tabulator-tables";

    import { fetchDelete, fetchGet, fetchPost } from "../utils/utilsFetch.js";

    import { addToCart, removeFromCart, getCartCount } from "../utils/utils.js";

    import { pdfShowModal, pdfDownload } from "../utils/generatePDF.js";

    import { getLocaleResource } from "../utils/locales.js";

    import { cartTableColumns } from "../utils/utilsTabulator.js";

    import {
        isLoading,
        messageObject,
        client,
        locale,
        cartValue,
        isMobile,
    } from "../stores.js";

    let table,
        tableElement,
        cart = [];

    onMount(async () => {
        $isLoading = true;

        table = new Tabulator(tableElement, {
            height: "100%",
            // data: cart,
            layout: "fitDataFill",
            vertAlign: "middle",
            // columnCalcs: "both",
            columns: cartTableColumns,
        });

        await getCart();

        $isLoading = false;
    });

    async function getCart() {
        cart = await fetchGet(`/api/cart`);
        table.replaceData(cart);
        console.log(cart);
    }

    let showDeleteModal;
    async function emptyCart() {
        cart = await fetchDelete(`/api/cart`);
        table.replaceData([]);
    }

    let inputAddress, inputPerson, inputPhone, inputNote;

    let showOrderSentSuccessfully;
    let showModal;

    function checkMinimumOrder() {
        if ($cartValue <= 400) {
            showModal = true;
        } else {
            sendOrder();
        }
    }

    async function sendOrder() {
        if ($client.canPlaceOrder) {
            $isLoading = true;

            if ($cartValue <= 400) {
                await addToCart("DOSTAVA", 1);
            }

            let result = await fetchPost(`/api/cart`, {
                inputAddress,
                inputPerson,
                inputPhone,
                inputNote,
            });

            if (result.success) {
                showOrderSentSuccessfully = true;
                cart = [];
                await getCartCount();
            } else {
                $messageObject = {
                    showMessage: true,
                    type: "error",
                    message: result.message,
                };
            }

            $isLoading = false;
        } else {
            $messageObject = {
                showMessage: true,
                type: "error",
                message:
                    "Vaš dug je 45 ili više dana van valute. Molimo da izmirite svoja dugovanja kako bi mogli napraviti narudžbu. Hvala na razumijevanju!",
            };
        }
    }
</script>

<Modal bind:showModal>
    <div slot="title" />
    <div slot="body">
        <div class="modal-message">
            Sve narudzbe ispod 400KM (bez pdv) kupac preuzima trošak dostave
            robe.

            <br />
            <br />

            Trenutna narudzba je {$cartValue}KM.
        </div>

        <div class="buttons">
            <button
                class="btn btn-blue"
                on:click={() => {
                    sendOrder();
                    showModal = false;
                }}
            >
                <span>
                    <b>POSALJI NARUDZBU</b> (Prihvatam trošak dostave 10KM bez pdv)
                </span>
            </button>

            <button
                class="btn btn-green"
                on:click={() => {
                    showModal = false;
                }}
            >
                Dopuni
            </button>
        </div>
    </div>
</Modal>

<DeleteModal
    bind:showDeleteModal
    deleteMessage={getLocaleResource($locale, "areYouSure")}
    deleteCallback={() => {
        emptyCart();
    }}
/>

{#if showOrderSentSuccessfully}
    <div class="success">
        <div class="message">
            <i class="fas fa-check" />
            Narudžba uspješno poslana.
            <!-- Успешно испратена нарачка -->
        </div>
        <br />
        <div class="info">Proverite email za potvrdu</div>
    </div>
{:else}
    <div class="container">
        <div class="header">
            <div class="header-row">
                <b>{getLocaleResource($locale, "cart")}</b>

                <!-- {$client.email} -->

                {#if cart && cart.length > 0}
                    <span style="background: yellow; padding: 5px;">
                        <b>{getLocaleResource($locale, "total")}:</b>
                        {$cartValue?.toFixed(2)} KM (bez PDV)
                    </span>
                {/if}

                <button
                    class="header-item btn btn-red"
                    on:click={() => {
                        let data = {
                            client: $client,
                            cart: cart,
                        };

                        if ($isMobile) {
                            pdfDownload(data);
                        } else {
                            pdfShowModal(data);
                        }
                    }}
                >
                    PDF Ponuda
                </button>

                <button
                    style="margin-left: auto;"
                    class="header-item btn btn-black"
                    on:click={() => {
                        showDeleteModal = true;
                    }}
                >
                    {getLocaleResource($locale, "emptyTheContent")}
                </button>
            </div>

            <div class="header-row">
                <input
                    type="text"
                    placeholder={getLocaleResource($locale, "address")}
                    bind:value={inputAddress}
                />

                <input
                    type="text"
                    placeholder={getLocaleResource($locale, "person")}
                    bind:value={inputPerson}
                />

                <input
                    type="text"
                    placeholder={getLocaleResource($locale, "phone")}
                    bind:value={inputPhone}
                />

                <input
                    type="text"
                    placeholder={getLocaleResource($locale, "note")}
                    bind:value={inputNote}
                />

                <button
                    class="header-item btn btn-blue"
                    on:click={checkMinimumOrder}
                >
                    {getLocaleResource($locale, "placeOrder")}
                </button>
            </div>
        </div>

        <div class="content">
            <div class="table" bind:this={tableElement} />
        </div>
    </div>
{/if}

<style>
    .container {
        display: grid;
        grid-template-rows: auto 1fr;
        grid-template-columns: 1fr;
        /* calc sprecuva tabelata da ide nadvor od content*/
        /* grid-template-rows: 30px 45px calc(100vh - 95px);  */
        height: 100%;
    }

    .header {
        grid-row: 1/2;

        display: flex;
        flex-direction: column;

        padding: 10px;
        gap: 10px;
    }

    .header-row {
        display: flex;
        gap: 10px;
        align-items: center;
        flex-wrap: wrap;
    }

    input {
        width: 130px;
    }

    .content {
        padding: 0px 10px 10px 10px;
        grid-row: 2/-1;

        overflow: auto;
    }

    .table {
        border-radius: 3px;
    }

    .success {
        height: 100%;
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .message {
        font-size: 40px;

        display: flex;
    }

    .success i {
        margin-right: 30px;
        color: rgb(76, 182, 60);
    }

    .info {
        font-size: 20px;
        opacity: 0.5;
    }

    .buttons {
        display: flex;
        justify-content: space-around;
    }

    .modal-message {
        font-size: 20px;
        margin-bottom: 20px;
        text-align: center;
    }
</style>
